const destinations = {
  bot: {
    title: "1. Telegram Bot Configuration",
    description: "Your destination channels and groups use one private Telegram bot credential tied to your signed-in account. Stored tokens are never returned to this browser or shared with other users.",
    tokenLabel: "Telegram Bot Token",
    placeholderNew: "123456789:ABCdefGhIJKlmNoPQRsTUVwxyZ",
    placeholderReplace: "Enter a new token to replace the stored credential",
    save: "Save token",
    saving: "Saving",
    showToken: "Show bot token",
    hideToken: "Hide bot token",
    stored: "Stored securely",
    notConfigured: "Token not configured",
    acquirePrefix: "Acquire a token from",
    acquireSuffix: "Saving stores or replaces only your account’s credential in Supabase Vault.",
  },
  targets: {
    title: "2. Destination Channels & Groups",
    description: "Manage your own public or private Telegram channels and groups. Only your signed-in account can list, edit, test, or publish to these targets.",
    friendlyName: "Friendly Name",
    friendlyNamePlaceholder: "e.g. Tech Announcements",
    channelId: "Channel ID or Username",
    channelIdPlaceholder: "e.g. @my_channel or -100123456",
    add: "Add",
    addTarget: "Add destination",
    emptyTitle: "No destinations defined yet",
    emptyDescription: "Add a friendly target channel or group using the form above.",
    active: "Active",
    muted: "Muted",
    toggle: "Toggle active state for {{name}}",
    connected: "Connected",
    failed: "Failed",
    test: "Test connection",
    testing: "Testing connection",
    remove: "Remove destination {{name}}",
  },
  feedback: {
    verificationSuccessful: "Verification successful",
    verificationFailed: "Verification failed",
    saveTokenFirst: "Save the Telegram Bot Token securely before testing a destination.",
    verificationFallback: "Verification failed.",
    testPublished: "Verified! Test message published to {{channelId}}.",
    connectionFallback: "Connection failed. Check the bot token and admin privileges.",
    networkError: "An unexpected network error occurred.",
    enterToken: "Enter a Telegram Bot Token before saving.",
    tokenStored: "Bot token stored securely for your account.",
    tokenSaveFailed: "The bot token could not be saved. Please try again.",
    targetNameRequired: "Enter a friendly name for the destination.",
    channelIdRequired: "Enter a Telegram channel ID or username.",
  },
  guide: {
    title: "Multiple Destination Guide",
    intro: "Configure your private bot to broadcast curated content to your own target feeds. Other TGReposter users have separate bot credentials and destination lists.",
    adminTitle: "Assign Admin Privileges",
    adminDescription: "The bot must be added as an Administrator in every destination channel or group. Ensure it has “Post Messages” permission.",
    privateTitle: "Support Private Channels",
    privateDescriptionPrefix: "For private channels, retrieve the numeric channel ID (typically starting with",
    privateDescriptionSuffix: ") by forwarding a post from the channel to a diagnostic bot such as",
    multiTitle: "Multi-Publishing Flow",
    multiDescription: "When you publish from the Content Inbox, the server sends the message to every checked active destination.",
    footer: "All destinations run concurrently. If one target is temporarily unavailable or lacks permission, other active destinations can still receive the post.",
  },
} as const;

export default destinations;
